// extracted by mini-css-extract-plugin
export default {"star":"rating_star__T8zrv","filled":"rating_filled__JwjbK","empty":"rating_empty__Zu5Jy","rating":"rating_rating__m7zSb"};